module.exports = __webpack_public_path__ + "static/img/logon.68dc4b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/km/logon.png
// module id = alCw
// module chunks = 2